<template>
  <v-layout class="mb-12">
    <v-expand-transition @after-leave="afterLeave">
      <v-container v-show="showInstallPopup" ref="container">
        <v-flex>
          <v-card>
            <v-card-title>
              <v-avatar size="36px" class="mr-2">
                <img :alt="$t('profile.avatar')" :src="client.logo">
              </v-avatar>
              <h3 class="title pl-2 pr-4">{{headline}}</h3>
            </v-card-title>
            <v-card-text>
              <div class="description" v-html="description"></div>
            </v-card-text>
            <v-card-actions class="text-right">
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="hidePopup">{{ $t('pushNotification.requestDenyButtonText') }}</v-btn>
              <v-btn color="primary" @click="forwardToInstall">{{buttonText}}</v-btn>
            </v-card-actions>
            <button type="button" @click="close" class="close" v-if="!persistent">
              <v-icon>{{ icons.mdiClose }}</v-icon>
            </button>
          </v-card>
        </v-flex>
      </v-container>
    </v-expand-transition>
  </v-layout>
</template>

<script>
/*
  this works only on Chrome (Mobile/Desktop) and iOS!
*/
  import _ from 'lodash';
  import {mdiClose} from '@mdi/js';
  import {storage} from '@/store';
  import {mapGetters} from 'vuex';
  import isFeatureSupported from '@/utils/isFeatureSupported';

  export default {
    name: 'InstallWebappPopup',
    props: ['data'],
    data() {
      return {
        showInstallPopup: false,
        promotionStorage: JSON.parse(storage.getItem('promotion')),
        installPrompt: null,
        icons: {
          mdiClose
        }
      }
    },
    computed: {
      ...mapGetters(['client', 'device', 'installPWAEvent']),
      headline() {
        if (_.get(this.device, 'device.type') === 'desktop') {
          return this.$t('installPrompt.installWebappHeadlineDesktop');
        }
        return this.$t('installPrompt.installWebappHeadlineMobile');
      },
      description() {
        if (_.get(this.device, 'device.type') === 'desktop') {
          return this.$t('installPrompt.installWebappDescriptionDesktop', {name: this.client.name});
        }
        return this.$t('installPrompt.installWebappDescriptionMobile', {name: this.client.name});
      },
      buttonText() {
        if (_.get(this.device, 'device.type') === 'desktop') {
          return this.$t('installPrompt.installWebappButtonDesktop');
        }
        return this.$t('installPrompt.installWebappButtonMobile');
      },
      persistent() {
        return _.get(this.data, 'persistent', false)
      },
      tokenUrl() {
        const location = new URL(window.location.href);
        const pathName = location.pathname.replace('index.html', '');
        return `${location.origin}${pathName}#/install-webapp`;
      },
      clientName() {
        return _.get(this.device, 'client.name');
      }
    },
    mounted() {
      if (!window.matchMedia('(display-mode: standalone)').matches && !(storage.getItem('pwaHidePopup')) && isFeatureSupported('pwa')) {
        this.showInstallPopup = true;
      }
    },
    methods: {
      afterLeave() {
        this.promotionStorage = JSON.parse(storage.getItem('promotion'));
        storage.setItem('promotion', JSON.stringify({discreetWebappInstaller: true, ...this.promotionStorage}));
        this.$emit('setInstallPopupPosition');
      },
      forwardToInstall() {
        window.location.href = this.tokenUrl;
      },
      close() {
        this.showInstallPopup = false;
      },
      hidePopup() {
        this.showInstallPopup = false;
        storage.setItem('pwaHidePopup', 1);
      }
    },
    watch: {
      persistent(to) {
        if (to && !(storage.getItem('pwaHidePopup'))) {
          this.showInstallPopup = true;
          // container won't set correct height after closed by @after-leave
          this.$refs.container.style.height = 'auto';
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .close {
    position: absolute;
    right: 4px;
    top: 4px;
  }
  .v-card::v-deep .v-card__title {
    word-break: normal;
    flex-wrap: nowrap;
    align-items: center;
    h3 {
      line-height: 1.3em;
    }
  }
  .v-card::v-deep .v-card__actions {
    padding-top: 0;
  }
</style>
